import { type Cell } from "@tanstack/react-table";
import { useMemo } from "react";

import { type AggregationFnOption, noneOption } from "../grouping-aggregations";
import { type ProcessedDataGridColumnDef } from "../useColumnState";

export const useSelectedAggregationFn = <T, TData>(
	cell: Cell<T, unknown>,
	columnDef: ProcessedDataGridColumnDef<T, TData>,
	aggregationOptions: Map<string, AggregationFnOption<unknown>>
) => {
	const selectedAggregationFn = useMemo<AggregationFnOption<TData>>(() => {
		const selectedOption = [...aggregationOptions.values()].find(
			(option) => option.value === columnDef.aggregationFn
		);
		return (selectedOption || noneOption) as AggregationFnOption<TData>;
	}, [aggregationOptions, cell.column.columnDef?.aggregationFn, columnDef.aggregationFn]);

	return selectedAggregationFn;
};
